export default __webpack_public_path__ + "static/google-pay-049b4e20cd1fad85bec41d596d24ea2c.gif";